import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  createIndeedFlexPastShift,
  type CreateIndeedFlexPastShiftParams,
} from 'api/admin/indeedFlex/createIndeedFlexPastShift'
import { indeedFlexKeys } from './keys'

export const useCreateIndeedFlexPastShiftMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: CreateIndeedFlexPastShiftParams) =>
      createIndeedFlexPastShift(params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.shiftIssues(),
      })
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.jobShifts(),
      })
    },
  })
}
